import { render, staticRenderFns } from "./ContactLabel.vue?vue&type=template&id=08fb45d3&scoped=true&"
import script from "./ContactLabel.vue?vue&type=script&lang=js&"
export * from "./ContactLabel.vue?vue&type=script&lang=js&"
import style0 from "./ContactLabel.vue?vue&type=style&index=0&id=08fb45d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fb45d3",
  null
  
)

export default component.exports